import classNames from 'classnames';
import ReloadIcon from '../../../assets/svg/reload.svg?react';
import FJUtil from '../../../util/FJUtil';
import { useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react';
import styles from './FJImage.module.less';
import FJResourceItemLoading from '../FJResourceItemLoading/FJResourceItemLoading';
import FJConstant from '../../../constants/FJConstant';
import PropTypes from 'prop-types';
import FJEvent from '../../../store/FJEvent';
const FJImage = (props, ref) => {
    const {
        imgSrc,
        boxClassName,
        imgClassName,
        loadingClassName,
        isShowLoading = false,
        style,
        children,
        isLoading,
        onClick,
        loadCallback,
        onRefresh,
        reloadStyle,
        addRefreshEvent = false,
    } = props;
    const [stateImgUrl, setStateImgUrl] = useState(imgSrc);
    const [stateIsLoadError, setStateIsLoadError] = useState(false);
    const [stateIsLoaded, setStateIsLoaded] = useState(false);
    const stateIsLoading = isShowLoading && !stateIsLoaded && !stateIsLoadError;
    const unsubscribe = useRef(null);
    const _imgRef = useRef(null);
    useImperativeHandle(ref, () => ({
        refresh: _refresh,
    }));
    useEffect(() => {
        if (!_imgRef.current) return;
        _imgRef.current.src = imgSrc;
        setStateIsLoaded(false);
        return () => {
            FJUtil.releaseImageMemory(_imgRef.current);
        };
    }, []);
    useEffect(() => {
        // 如果需要显示loading，则设置状态为loading
        if (imgSrc !== stateImgUrl) {
            setStateImgUrl(imgSrc);
            loadCallback && loadCallback(FJConstant.LOADING);
        }
    }, [imgSrc]);

    const _refresh = e => {
        e && FJUtil.forbidEvent(e);
        setStateIsLoadError(false);
        setStateIsLoaded(false);
        setStateImgUrl(FJUtil.getReloadNewUrl(imgSrc));
        loadCallback && loadCallback(FJConstant.LOADING);
        onRefresh && onRefresh();
        if (addRefreshEvent) {
            unsubscribe.current && unsubscribe.current();
            FJEvent.dispatch(FJConstant.REFRESH_IMAGE);
        }
    };
    const _sourceLoaded = () => {
        setStateIsLoadError(false);
        setStateIsLoaded(true);
        loadCallback && loadCallback(FJConstant.SUCCESS);
    };
    const _sourceError = () => {
        setStateIsLoadError(true);
        setStateIsLoaded(false);
        loadCallback && loadCallback(FJConstant.ERROR);
        if (addRefreshEvent) {
            unsubscribe.current = FJEvent.subscribe(FJConstant.REFRESH_IMAGE, _refresh);
        }
    };
    const _onClick = e => {
        if (stateIsLoading || isLoading) {
            return;
        }
        onClick && onClick(e);
    };

    return (
        <div className={classNames(boxClassName)} onClick={_onClick} style={style}>
            <img
                src={stateImgUrl}
                className={classNames(styles.img, imgClassName)}
                onLoad={_sourceLoaded}
                onError={_sourceError}
                style={{ opacity: stateIsLoadError || stateIsLoading ? 0 : 1 }}
                loading='lazy'
                ref={_imgRef}
            />
            {stateIsLoadError && (
                <div className={styles.reload} style={{ ...reloadStyle }} onClick={_refresh}>
                    <ReloadIcon />
                </div>
            )}
            {children}
            {(stateIsLoading || isLoading) && <FJResourceItemLoading className={loadingClassName} />}
        </div>
    );
};
FJImage.propTypes = {
    imgSrc: PropTypes.string,
    boxClassName: PropTypes.string,
    imgClassName: PropTypes.string,
    loadingClassName: PropTypes.string,
    isShowLoading: PropTypes.bool,
    style: PropTypes.object,
    children: PropTypes.node,
    isLoading: PropTypes.bool,
    onClick: PropTypes.func,
    loadCallback: PropTypes.func,
    onRefresh: PropTypes.func,
    reloadStyle: PropTypes.object,
    addRefreshEvent: PropTypes.bool,
};
export default forwardRef(FJImage);
